import * as COLORS from './colors';

export const getAlertColor = (alertType: number) => {
  switch (alertType) {
    case 8: // Unit not sent data for a period of time
    case 26: // Unit out of route
      return '#fd7e14';
    default:
      return COLORS.COLOR_7P_TEAL;
  }
};
